import { SET_TYPE_HEADER } from "./typeHeader.types";
export const setTypeHeaderAction = data => dispatch => {
  dispatch({
    type: SET_TYPE_HEADER,
    payload: data
  });
};